import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventAdhocWorkflowTriggered } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import Actor from '../actor';
type AdhocWorkflowTriggeredProps = {
  event: UserTimelineEventAdhocWorkflowTriggered['data'];
};
const AdhocWorkflowTriggered = t0 => {
  const $ = _c(13);
  const {
    event
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.events.adhocWorkflowTriggered"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== event.actor) {
    t2 = <Actor actor={event.actor} />;
    $[1] = event.actor;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== event.config.verificationChecks) {
    t4 = event.config.verificationChecks.map(_temp2).join(", ");
    $[5] = event.config.verificationChecks;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-primary text-label-2 first-letter:uppercase">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-wrap gap-1 text-body-2 text-tertiary md:flex-nowrap">{t2}{t3}{t5}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default AdhocWorkflowTriggered;
function _temp($) {
  return $.init;
}
function _temp2(check) {
  return check.kind;
}